import { useState, useEffect } from "react";
import { axiosCarvenui } from "../../util/integration";

export const useModels = (selectedBrands) => {
  const [brandModels, setBrandModels] = useState({});
  const [loadingModels, setLoadingModels] = useState({});
  const [collapseModels, setCollapseModels] = useState({});

  useEffect(() => {
    const fetchModelsForBrands = async () => {
      const brandIds = [...selectedBrands].map((brand) => brand.id);

      for (const brandId of brandIds) {
        if (!brandModels[brandId] && !loadingModels[brandId]) {
          setLoadingModels((prev) => ({ ...prev, [brandId]: true }));

          try {
            const response = await axiosCarvenui.get(
              `/car_model/?page=1&page_size=100&brand=${brandId}`
            );

            const models = response.data.results.map((model) => ({
              ...model,
              brand: brandId,
            }));

            setBrandModels((prev) => ({
              ...prev,
              [brandId]: models,
            }));

            setCollapseModels((prev) => ({
              ...prev,
              [brandId]: true,
            }));
          } catch (error) {
            console.error(`Error fetching models for brand ${brandId}:`, error);
          } finally {
            setLoadingModels((prev) => ({ ...prev, [brandId]: false }));
          }
        }
      }

      const currentBrandIds = new Set(brandIds);
      setBrandModels((prev) => {
        const cleaned = {};
        Object.keys(prev).forEach((brandId) => {
          if (currentBrandIds.has(parseInt(brandId))) {
            cleaned[brandId] = prev[brandId];
          }
        });
        return cleaned;
      });

      setLoadingModels((prev) => {
        const cleaned = {};
        Object.keys(prev).forEach((brandId) => {
          if (currentBrandIds.has(parseInt(brandId))) {
            cleaned[brandId] = prev[brandId];
          }
        });
        return cleaned;
      });

      setCollapseModels((prev) => {
        const cleaned = {};
        Object.keys(prev).forEach((brandId) => {
          if (currentBrandIds.has(parseInt(brandId))) {
            cleaned[brandId] = prev[brandId];
          }
        });
        return cleaned;
      });
    };

    if (selectedBrands.size > 0) {
      fetchModelsForBrands();
    } else {
      setBrandModels({});
      setLoadingModels({});
      setCollapseModels({});
    }
  }, [selectedBrands]);

  const toggleCollapseForBrand = (brandId) => {
    setCollapseModels((prev) => ({
      ...prev,
      [brandId]: !prev[brandId],
    }));
  };

  const getModelsForBrand = (brandId) => {
    return brandModels[brandId] || [];
  };

  const isLoadingForBrand = (brandId) => {
    return loadingModels[brandId] || false;
  };

  const isCollapsedForBrand = (brandId) => {
    return collapseModels[brandId] || false;
  };

  return {
    brandModels,
    getModelsForBrand,
    isLoadingForBrand,
    isCollapsedForBrand,
    toggleCollapseForBrand,
  };
};
